<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <li
    class="pointer-events-none grid h-8 select-none place-content-center rounded-lg border border-dashed border-auth-border py-1 pl-3 text-center text-xs text-auth-muted dark:border-white/10 dark:text-auth-muted-dark"
  >
    <slot>{{ t('SIDEBAR.NO_ITEMS') }}</slot>
  </li>
</template>
